import {
  oauthAction,
  oauthEmail,
  oauthError,
  oauthFirstname,
  oauthLastname,
  oauthProvider,
  oauthToken,
} from '@gonfalon/bootstrap-data/bootstrapData';
import { googleOauthClientId } from '@gonfalon/constants/constants';
import { isGithubOAuthSignUpEnabled, isGoogleOAuthSignUpEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';

import {
  GITHUB_AUTH_KIND,
  GOOGLE_AUTH_KIND,
  VERCEL_MARKETPLACE_AUTH_KIND,
  type OAuthProviderKind,
} from '#utils/accounts/accountTypes';

export function normalizeOAuthProvider(provider: string | undefined): OAuthProviderKind | string | undefined {
  switch (provider) {
    case 'google':
      return GOOGLE_AUTH_KIND;
    case 'github':
      return GITHUB_AUTH_KIND;
    case 'vercel':
      return VERCEL_MARKETPLACE_AUTH_KIND;
    default:
      return provider;
  }
}

export function getOAuthData() {
  return {
    error: oauthError(),
    token: String(oauthToken()),
    firstName: oauthFirstname(),
    lastName: oauthLastname(),
    email: oauthEmail(),
    action: oauthAction(),
    provider: normalizeOAuthProvider(oauthProvider()),
  };
}

export function shouldEnableGoogleOAuthSignUp() {
  if (isGoogleOAuthSignUpEnabled() && googleOauthClientId()) {
    return true;
  }
  return false;
}

export function shouldEnableGithubOAuthSignUp(): boolean {
  return isGithubOAuthSignUpEnabled();
}
